










import { Component, mixins } from '@niknevis/vue-modules'
import { FilterEntitySearchMixin } from '@/modules/common/filter/mixins/filterEntitySearchMixin'
import AdminCampaignSearch from '@/modules/base-campaign/components/admin/AdminCampaignSearch.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    AdminCampaignSearch
  }
})
export default class AdminCampaignSearchFilter extends mixins(FilterEntitySearchMixin) {

  @Prop({ default: 3 }) minimumCharacter: number
  @Prop({ default: true }) lazy: boolean
}
